// extracted by mini-css-extract-plugin
export var activeDot = "_4n-c";
export var buttonContainer = "_4n-9";
export var channelButton = "_4n-a";
export var content = "_4n-0";
export var contentFull = "_4n-2";
export var contentThird = "_4n-1";
export var contentWrapper = "_4n-7";
export var description = "_4n-5";
export var heightShort = "_4n-e";
export var image = "_4n-3";
export var imageContainer = "_4n-4";
export var selectButton = "_4n-d";
export var spinnerContainer = "_4n-b";
export var titleContent = "_4n-8";
export var titleWrapper = "_4n-6";